export { type FooterBottomProps, default as FooterBottom } from './FooterBottom';
